'use client';

import ToastContext from "@/providers/toast-context";
import classes from "./toast_container.module.css";
import { useContext } from "react";
import Toast from "../common/toast/toast";
import { AnimatePresence, motion } from "framer-motion";

export default function ToastContainer({}) {
    const {toasts} = useContext(ToastContext);

    return <div className={`${classes["toasts"]}`}>
        <div className={`${classes["toasts-inner"]}`}>
            <AnimatePresence>
                {toasts.map(toast => <motion.div 
                    key={toast.id}
                    initial={{x: -600, maxHeight: 0}}
                    animate={{x: 0, maxHeight: 200}}
                    exit={{x: -600, maxHeight: 0}}
                >
                    <Toast {...toast} />
                </motion.div>)}
            </AnimatePresence>
        </div>
    </div>
}